<template>
  <Layout>
    <Content :style="{ 'padding': '10px' }">
      <Breadcrumb :style="{ margin: '5px 0' }">
        <BreadcrumbItem>商品管理>单品套餐</BreadcrumbItem>
      </Breadcrumb>
      <Card>
        <Card :style="{ 'padding': '0px 5px', 'margin-bottom': '5px' }">
          <span class="search_span_width">
            <span class="search_span_width_part1">商品ID:</span>
            <Input v-model="search.id" placeholder="请输入内容" clearable :style="{ 'width': '150px' }"></Input>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">产品名称:</span>
            <Input v-model="search.name" placeholder="请输入内容" clearable :style="{ 'width': '150px' }"></Input>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">上架渠道：</span>
            <Select v-model="search.channel" clearable style="width:200px">
              <Option v-for="item in channel_list" :value="item.id" :key="item.index">{{ item.name }}</Option>
            </Select>
          </span>
          <Button type='primary' icon="ios-search" :style="{ 'margin-left': '20px' }"
            @click="listingProduct(1)">搜索</Button>
          <span :style="{ 'text-align': 'center', margin: '0px 0px 0px 14px' }">
            <Button type='primary' @click="$router.push('/goods/goodsinfo')">添加单品</Button>
          </span>
        </Card>

        <Card>
          <Table :columns="producetListingColumns" :data="producet_listing_list"></Table>
          <Page :total="recordListingTotal" :current="listingPage" :page-size="15" :show-elevator="true"
            @on-change="listingProduct" />
        </Card>

      </Card>
    </Content>
  </Layout>
</template>
<script>
const OSS = require('ali-oss');
export default {
  data() {
    return {
      split: 0.5,
      search: {
        channel: '',
        name: '',
        product_type: 1,
        is_channel: 2,
      },
      channel_arr: [],
      listingSearch: {
        channel: '',
        is_listing: 1
      },
      delistSearch: {
        channel: '',
        is_listing: 1
      },
      produceInfo: {
        id: 0,
        product_sn: '',
        product_type: 1,
        channel: '',
        product_id: 0,
      },
      productChannelInfo: {
        id: 0,
        product_id: 0,
        product_name: "",
        agent_config: [],
        channel: '',
        ori_total_fee: 0,
        total_fee: 0,
        details: '',
        is_listing: 1,
        grade_0: 0,
        grade_name_0: "渠道管理员",
        agent_zero_price: 0,
        grade_1: 1,
        grade_name_1: "钻石服务商",
        agent_one_price: 0,
        grade_2: 2,
        grade_name_2: "运营服务商",
        agent_two_price: 0,
        agent_channel_config: [],
        remark: ''
      },
      recordTotal: 0,
      page: 1,
      listingPage: 1,
      recordListingTotal: 0,
      file: null,
      upLoadAgreementFile: null,
      loadingStatus: false,
      loadingStatusFile: false,
      upLoadProgress: 0,
      upLoadProgress_show: false,
      upLoadAgreement: 0,
      upLoadAgreement_show: false,
      producetListModal: false,
      channel_list: [],
      producet_listing_list: [],
      producetListingColumns: [
        { title: '商品ID', key: 'id', align: 'center' },
        {
          title: '产品名称', key: 'product_name', align: 'center', render: (h, params) => {
            let product_name = params.row.product_name;
            if (params.row.remark !== '') {
              product_name += "(" + params.row.remark + ")";
            }
            return h('span', {}, product_name);
          }
        },
        {
          title: '商品类型', key: 'product_type', align: 'center', render: (h, params) => {
            let product_type = '单品';
            if (params.row.product_type == '1') {
              product_type = '单品';
            } else if (params.row.product_type == '2') {
              product_type = '服务';
            } else if (params.row.product_type == '3') {
              product_type = '产品套餐';
            }
            return h('span', {}, product_type);
          }
        },
        { title: '上架渠道', key: 'channel_list', align: 'center' },
        {
          title: '单品价格', key: 'ori_total_fee', align: 'center', render: (h, params) => {
            let ori_total_fee = "0";
            if (params.row.ori_total_fee > 0) {
              ori_total_fee = '￥' + params.row.ori_total_fee;
            } else {
              ori_total_fee = params.row.ori_total_fee;
            }
            return h('span', {}, ori_total_fee);
          }
        },
        {
          title: '零售价', key: 'total_fee', align: 'center', render: (h, params) => {
            let total_fee = "0";
            if (params.row.total_fee > 0) {
              total_fee = '￥' + params.row.total_fee;
            } else {
              total_fee = params.row.total_fee;
            }
            return h('span', {}, total_fee);
          }
        },
        {
          title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns = []
            btns.push(
              h('Button', {
                props: { type: 'warning', size: 'small', disabled: params.row.sale_type == 2 ? true : false },
                style: { marginRight: '5px', marginBottom: '5px' },
                on: {
                  click: () => {
                    this.$router.push('/goods/goodsinfo?id=' + params.row.id)
                  }
                }
              }, '编辑'),
            );
            return h("div", btns);
          },
        }
      ],
      uploadHeader: {
        "Authorization": localStorage.getItem('token')
      },
    }
  },
  mounted: function () {
    this.listingProduct();
    this.getChannel();
  },
  computed: {
    getUploadUrl() {
      return process.env.VUE_APP_APIHOST + '/admin/channel/upload';
    },
  },
  methods: {
    handleUpload(file) {
      this.file = file;
      return false;
    },
    handleAgreementUpload(file) {
      this.upLoadAgreementFile = file;
      return false;
    },
    getChannel() {
      this.http.get('/admin/common/getChannelList', { params: { 'key': 'app_channel' } }).then(response => {
        let data = response.data;
        console.log(data);
        if (data.code !== 0) {
          alert(data.message);
        } else {
          this.channel_list = data.data;
        }
      }).catch(() => {
        this.$Message.error('网络错误');
      });
    },
    listingProduct(page = this.listingPage) {
      this.page = page;
      let p = { 'page': page }
      let params = Object.assign(this.search, p);
      this.http1.get('/produce/producetList', { params: params }).then(response => {
        let data = response.data;
        if (data.code !== 0) {
          this.$Message.error(data.message);
          return false;
        } else {
          this.producet_listing_list = data.data.list;
          this.recordListingTotal = data.data.total;
        }
      });
    },
    doUpload() {
      this.http.get('/admin/material/getUpoadVideoToken').then(response => {
        let data = response.data;
        console.log(data);
        if (data.StatusCode != 200) {
          this.$Message.error(data.message);
        } else {
          const config = data;
          console.log(config);

          const ossClient = new OSS({
            accessKeyId: config.AccessKeyId,
            accessKeySecret: config.AccessKeySecret,
            stsToken: config.SecurityToken,
            bucket: config.bucket,
            region: config.RegionId,
            secure: true,
            endpoint: 'oss-cn-zhangjiakou.aliyuncs.com'
          });

          const fileName = this.file.name;
          //const fileName = '风平IP智造'+this.app.app_version+'.exe'

          const progress = (p, _checkpoint) => {
            // Object的上传进度。
            this.upLoadProgress_show = true;
            this.upLoadProgress = parseInt(p * 100);
            //console.log(p); 
            // 分片上传的断点信息。
            //console.log(_checkpoint); 
          };

          ossClient.multipartUpload('freefishpc/channel/doc/' + fileName, this.file, { progress }).then(
            result => {
              this.file = null;
              this.channel.private_agreement = result.name;
              console.log(`channel upload ${fileName} succeeded, result === `, result)
            }).catch(
              err => {
                console.log(`channel upload ${fileName} failed === `, err);
              });
        }
      }).catch(() => {
        this.$Message.error('网络错误');
      });
    },
    successLoginLogo(response) {
      let data = response
      if (data.code != 0) {
        this.$Message.error(data.message);
        return true;
      }
      this.channel.login_logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successLogo(response) {
      let data = response
      if (data.code != 0) {
        this.$Message.error(data.message);
        return true;
      }
      this.channel.logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successIco(response) {
      let data = response
      if (data.code != 0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.ico = data.data.url;
      this.$Message.success('上传成功');
    },
    successMiniLoginLogo(response) {
      let data = response
      if (data.code != 0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.mini_login_logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successMiniHomeLogo(response) {
      let data = response
      if (data.code != 0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.mini_home_logo = data.data.url;
      this.$Message.success('上传成功');
    },
    closesavemodal() {
      this.showsavemodal = false;
    }
  }

}
</script>


<style lang='postcss'>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.box>div {
  height: 100%;
  flex: 1;
}
</style>